<template>
  <div class="content-container">
    <div class="">
      <CalendarSelect
        v-model="searchParams.date"
        style="display: block; width: 200px"
        mode="date"
      />
      <!-- <el-collapse-transition>
        <div v-show="searchShow" class="filter_container">
          <div class="section-box">
            <div class="das-form-container">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="child-w-80"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div></div
      ></el-collapse-transition> -->
    </div>

    <div v-loading="loading" class="mt-10 grid-container">
      <div class="card">
        <div class="card-title">HOẠT ĐỘNG</div>
        <hr />
        <GridVx
          id="agGrid1"
          ref="agGridOperation"
          style="height: calc(100% - 40px)"
          :columns="operationCols"
          :rows="operationRows"
          class="agGrid"
          :auto-size-cell="true"
          :auto-select-first-row="false"
          :context="context"
        />
      </div>
      <div class="col-2">
        <div class="card">
          <div class="card-title">TỔNG HỢP PHÒNG</div>
          <hr />
          <GridVx
            ref="agGridRoom"
            style="height: calc(100% - 30px)"
            :columns="roomCols"
            :rows="roomRows"
            class="agGrid"
            :auto-size-cell="true"
            :header-height="0"
            :auto-select-first-row="false"
            :context="context"
          />
        </div>
        <div class="card">
          <div class="card-title">TRẠNG THÁI DỌN PHÒNG</div>
          <hr />
          <GridVx
            ref="agGridHousekeeping"
            style="height: calc(100% - 30px)"
            :columns="housekeepingCols"
            :rows="housekeepingRows"
            class="agGrid"
            :auto-size-cell="true"
            :auto-select-first-row="false"
            :context="context"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="card">
          <div class="card-title">SAI LỆCH</div>
          <hr />
          <GridVx
            ref="agGridDiff"
            style="height: calc(100% - 30px)"
            :columns="diffCols"
            :rows="diffRows"
            class="agGrid"
            :auto-size-cell="true"
            :header-height="0"
            :auto-select-first-row="false"
            :context="context"
          />
        </div>
        <div class="card">
          <div class="card-title">ĐỐI CHIẾU CUỐI NGÀY</div>
          <hr />
          <GridVx
            ref="agGridEndDay"
            style="height: calc(100% - 30px)"
            :columns="endDayCols"
            :rows="endDayRows"
            class="agGrid"
            :auto-size-cell="true"
            :auto-select-first-row="false"
            :context="context"
          />
        </div>
      </div>
    </div>

    <el-dialog
      :title="`Chi tiết ${this.$t(`grid.row.${keyword}`)}`"
      :visible.sync="dialogDetailVisible"
      width="90%"
      :close-on-click-modal="false"
      @close="dialogDetailVisible = false"
    >
      <div v-loading="detailLoading" class="grid-scroll">
        <GridVx
          ref="agGrid"
          style="height: calc(40px + 340px + 10px)"
          :columns="detailColumns"
          :auto-select-first-row="false"
          row-selection="single"
          :rows="detailRows"
          class="agGrid"
          @selectionChanged="onSelectionChanged"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small"
            :disabled="!detailSelectedRow"
            @click="dialogBookingRoomDetailVisible = true"
          >
            {{ `Xem chi tiết đặt phòng` }}
          </button>
          <button
            class="btn primary small"
            @click="dialogDetailVisible = false"
          >
            {{ `Đóng` }}
          </button>
        </div>
      </span>
    </el-dialog>

    <BookingRoomDetailDialog
      v-model="dialogBookingRoomDetailVisible"
      :data="detailSelectedRow"
    />
  </div>
</template>

<script>
/* eslint-disable */
import paginationMixin from '@/mixins/paginationMixin'
import * as dayjs from 'dayjs'

import BookingRoomDetailDialog from './components/BookingRoomDetailDialog.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { CellRenderOpenDialogWhenCLicked } from '@/utils/cellRenders'

import { getHotelStatus, getHotelStatusDetail } from '@/api/reception/reception'
export default {
  components: {
    CalendarSelect,
    CellRenderOpenDialogWhenCLicked,
    BookingRoomDetailDialog
  },
  mixins: [paginationMixin],
  data() {
    return {
      // search box
      searchShow: true,
      context: null,

      searchParams: {
        date: dayjs().format('YYYY-MM-DD')
      },
      defaultSearchParams: {
        date: dayjs().format('YYYY-MM-DD')
      },

      loading: false,

      // row and column
      // operation
      operationRows: [
        { status: 'Dự kiến đi' },
        { status: 'Thực tế đi' },
        { status: 'Dự kiến đến' },
        { status: 'Phòng đã gán trước' },
        { status: 'Thực tế đến' },
        { status: 'Đang ở' },
        { status: 'Gia hạn chặng ở' },
        { status: 'Đi sớm' },
        { status: 'Phòng ở trong ngày' },
        { status: 'Đặt phòng tạo trong ngày' },
        { status: 'Walk-ins' },
        { status: 'Chuyển phòng' }
      ],
      operationCols: [
        {
          headerName: '',
          field: 'status',
          valueGetter: params => this.$t(`grid.row.${params.data.status}`)
        },
        {
          headerName: 'Phòng',
          field: 'o_quantity',
          cellRenderer: 'CellRenderOpenDialogWhenCLicked',
          cellRendererParams: {
            refName: 'agGridOperation',
            clickable: true
          }
        },
        {
          headerName: 'Người',
          field: 'v_quantity',
          cellRenderer: 'CellRenderOpenDialogWhenCLicked',
          cellRendererParams: {
            refName: 'agGridOperation',
            clickable: true
          }
        }
      ],

      roomRows: [],
      roomCols: [
        {
          headerName: '',
          field: 'status',
          valueGetter: params => this.$t(`grid.row.${params.data.status}`)
        },
        { headerName: '', field: 'o_quantity' }
      ],

      housekeepingRows: [],
      housekeepingCols: [
        {
          headerName: '',
          field: 'status',
          valueGetter: params => this.$t(`grid.row.${params.data.status}`)
        },
        { headerName: 'Có khách', field: 'o_quantity' },
        { headerName: 'Trống', field: 'v_quantity' }
      ],

      diffRows: [],
      diffCols: [
        {
          headerName: '',
          field: 'status',
          valueGetter: params => this.$t(`grid.row.${params.data.status}`)
        },
        { headerName: '', field: 'o_quantity' }
      ],

      endDayRows: [],
      endDayCols: [
        {
          headerName: '',
          field: 'status',
          valueGetter: params => this.$t(`grid.row.${params.data.status}`)
        },
        {
          headerName: 'Phòng',
          field: 'o_quantity',
          cellRenderer: 'CellRenderOpenDialogWhenCLicked',
          cellRendererParams: params => ({
            refName: 'agGridOperation',
            clickable: [
              'occupied',
              'totalOccupied',
              'occupiedNotInternal'
            ].some(item => item === params.data?.status)
              ? false
              : true
          })
        },
        {
          headerName: 'Người',
          field: 'v_quantity',
          cellRenderer: 'CellRenderOpenDialogWhenCLicked',
          cellRendererParams: params => ({
            refName: 'agGridOperation',
            clickable: [
              'occupied',
              'totalOccupied',
              'occupiedNotInternal'
            ].some(item => item === params.data?.status)
              ? false
              : true
          })
        },
        { headerName: 'Công suất', field: 'performance' }
      ],

      // dialog
      dialogDetailVisible: false,
      detailColumns: [
        { headerName: 'STT', field: 'no', width: 100 },
        { headerName: 'Mã đoàn', field: 'booking_nm', width: 150 },
        { headerName: 'Đặt phòng', field: 'sub_booking_group_id', width: 100 },
        { headerName: 'Danh xưng', field: 'name', width: 100 },
        { headerName: 'Tên', field: 'first_name', width: 100 },
        { headerName: 'Họ', field: 'last_name', width: 100 },
        { headerName: 'VIP', field: '', width: 100 },
        { headerName: 'Phòng', field: 'room_num', width: 100 },
        { headerName: 'Hạng phòng', field: 'room_level_nm', width: 150 },
        { headerName: 'Ngày đến', field: 'arrive_date' },
        { headerName: 'Ngày đi', field: 'depart_date' },
        { headerName: 'Số khách', field: 'num_of_guest', width: 100 },
        { headerName: 'Đoàn', field: '' },
        { headerName: 'Công ty', field: 'agent_nm' }
      ],
      detailRows: [],
      detailLoading: false,
      keyword: null,
      detailSelectedRow: null,

      // dialog
      dialogBookingRoomDetailVisible: false
    }
  },

  computed: {},

  watch: {
    'searchParams.date'(nv, ov) {
      this.fnGetHotelStatus()
    }
  },

  beforeMount() {
    this.context = { componentParent: this }
  },

  mounted() {
    this.fnGetHotelStatus()
  },

  methods: {
    // handle event
    opendialogByCellRenderComp(gridName, colName, rowIdx, params) {
      this.keyword = params.data?.status
      switch (gridName) {
        case 'agGridOperation':
        case 'agGridEndDay':
          this.dialogDetailVisible = true
          this.fnGetHotelStatusDetail()
          break
        default:
          break
      }
    },

    // handle dialog event
    onSelectionChanged(selectedRows) {
      this.detailSelectedRow = selectedRows[0]
    },

    // pagination
    // async onPageChanged(pageNum) {
    //   this.pageParams.pageNum = pageNum
    //   await this.fnGetListAgent()
    // },
    // async onPageSizeChange(pageSize) {
    //   this.pageParams.pageSize = pageSize
    //   this.pageParams.pageNum = 1
    //   await this.fnGetListAgent()
    // },

    // handle api call
    fnGetHotelStatus() {
      getHotelStatus(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.operationRows = res.map.action
            this.roomRows = res.map.total_physical_room
            this.housekeepingRows = res.map.housekeeping_status
            this.diffRows = res.map.diff_status
            this.endDayRows = res.map.end_of_day
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnGetHotelStatusDetail() {
      getHotelStatusDetail({
        date: this.searchParams.date,
        keyword: this.keyword
      })
        .then(res => {
          if (!res.is_error) {
            this.detailRows = res.data
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
// @import url('../../../styles/variables.scss');
$primary-color: #357456;
$input-bg-color: #f0f0f5;

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
.col-2,
.col-3 {
  display: grid;
  gap: 1rem;
  grid-template-rows: 1fr 2fr;
}

.card {
  border: 1px solid #d4d4d4;
  height: auto;
  padding: 15px 10px 10px;
  // background-color: $input-bg-color;
  border-radius: 5px;
  .card-title {
    font-weight: 700;
    color: $primary-color;
    text-transform: uppercase;
    // margin: 10px 0;
  }
  .agGrid {
    width: 100%;
    height: auto;
  }
}
</style>
